import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Employee } from '@models/company';
import { Brokerage } from '@models/matter';
import { UntilDestroy } from '@ngneat/until-destroy';

export interface CreateBrokerData {
	firstName: string;
	lastName: string;
	brokerage: Brokerage;
}

@UntilDestroy()
@Component({
	selector: 'app-create-broker',
	templateUrl: './create-broker.component.html',
	standalone: false,
})
export class CreateBrokerComponent implements OnInit {
	public firstName!: string;
	public lastName!: string;
	public brokerage: Brokerage;
	public required = true;

	constructor(
		public dialogRef: MatDialogRef<CreateBrokerComponent>,
		@Inject(MAT_DIALOG_DATA) public data: CreateBrokerData,
	) {}

	ngOnInit(): void {
		const { firstName, lastName, brokerage } = this.data;

		this.firstName = firstName;
		this.lastName = lastName;
		this.brokerage = brokerage;
	}

	onSubmit(event: Employee) {
		this.dialogRef.close(event);
	}
}
